var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBookmark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.47 14.44-1.32-.8c-.06-.04-.24-.04-.3 0l-1.32.8c-1.08.66-2.14.76-2.99.28-.83-.47-1.29-1.41-1.29-2.64V5.03c0-2.44 1.33-3.78 3.75-3.78h4c2.42 0 3.75 1.34 3.75 3.78v7.05c0 1.24-.46 2.18-1.29 2.64-.35.2-.74.3-1.15.3-.58 0-1.21-.19-1.84-.58zm-.54-2.09 1.32.8c.59.36 1.13.45 1.47.26.33-.19.52-.68.52-1.34V5.03c0-1.6-.67-2.28-2.25-2.28h-4c-1.58 0-2.25.68-2.25 2.28v7.05c0 .66.19 1.15.52 1.34.34.19.88.1 1.47-.26l1.32-.8c.29-.17.62-.25.95-.25.33 0 .66.08.93.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.34-7.75-7.82V11.9c0-4.66 1.68-7.02 5.44-7.65.4-.07.79.21.86.62.07.41-.21.79-.62.86-3.01.5-4.19 2.23-4.19 6.17v3.03c0 4.61 1.69 6.32 6.25 6.32h6c4.56 0 6.25-1.71 6.25-6.32V11.9c0-4-1.22-5.73-4.36-6.2a.747.747 0 0 1-.63-.85c.06-.41.44-.69.85-.63 3.9.58 5.64 2.94 5.64 7.68v3.03c.01 5.48-2.31 7.82-7.74 7.82H9z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBookmark2);
export default __webpack_public_path__ + "static/media/vuesax-outline-bookmark-2.e8d1eb567491d9e11f7698c66b72ff65.svg";
export { ForwardRef as ReactComponent };